export default __webpack_public_path__ + "static/media/web-mockup.b1cf60f9.png";